import { render, staticRenderFns } from "./PFeature.vue?vue&type=template&id=08c82158&scoped=true&"
import script from "./PFeature.vue?vue&type=script&lang=ts&"
export * from "./PFeature.vue?vue&type=script&lang=ts&"
import style0 from "./PFeature.vue?vue&type=style&index=0&id=08c82158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c82158",
  null
  
)

export default component.exports